<ng-template #searchActions>
  <div class="search-actions">
    <button *ngIf="searchTerm" type="button" class="clear-search-btn" (click)="clearSearch()" aria-label="Clear search">
      <span nz-icon nzType="close"></span>
    </button>
    <span nz-icon nzType="search"></span>
  </div>
</ng-template>
<nz-tabset [nzDestroyInactiveTabPane]="true">
  <nz-tab nzTitle="Charts">
    <ng-template nz-tab>
      <app-charts></app-charts>
    </ng-template>
  </nz-tab>
  <nz-tab nzTitle="Dashboards">
    <ng-template nz-tab>
      <app-dashboards></app-dashboards>
    </ng-template>
  </nz-tab>
</nz-tabset>
